import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { SharedDataProvider } from './context/SharedDataContext';
import { RouteSEO } from './components/RouteSEO';

const Home = lazy(() => import('./pages/Home').then((module) => ({ default: module.Home })));
const About = lazy(() => import('./pages/About').then((module) => ({ default: module.About })));
const Privacy = lazy(() => import('./pages/Privacy').then((module) => ({ default: module.Privacy })));
const Terms = lazy(() => import('./pages/Terms').then((module) => ({ default: module.Terms })));
const Contact = lazy(() => import('./pages/Contact').then((module) => ({ default: module.Contact })));
const Dashboard = lazy(() => import('./pages/Dashboard').then((module) => ({ default: module.Dashboard })));

const HourlyToSalary = lazy(() => import('./components/calculators/HourlyToSalary').then((module) => ({ default: module.HourlyToSalary })));
const TakeHomePay = lazy(() => import('./components/calculators/TakeHomePay').then((module) => ({ default: module.TakeHomePay })));
const CostOfLiving = lazy(() => import('./components/calculators/CostOfLiving').then((module) => ({ default: module.CostOfLiving })));
const RetirementCalculator = lazy(() => import('./components/calculators/RetirementCalculator').then((module) => ({ default: module.RetirementCalculator })));
const LoanCalculator = lazy(() => import('./components/calculators/LoanCalculator').then((module) => ({ default: module.LoanCalculator })));
const InvestmentCalculator = lazy(() => import('./components/calculators/InvestmentCalculator').then((module) => ({ default: module.InvestmentCalculator })));
const InterestCalculator = lazy(() => import('./components/calculators/InterestCalculator').then((module) => ({ default: module.InterestCalculator })));
const BudgetCalculator = lazy(() => import('./components/calculators/BudgetCalculator').then((module) => ({ default: module.BudgetCalculator })));
const MortgageCalculator = lazy(() => import('./components/calculators/MortgageCalculator').then((module) => ({ default: module.MortgageCalculator })));
const SavingsGoalCalculator = lazy(() => import('./components/calculators/SavingsGoalCalculator').then((module) => ({ default: module.SavingsGoalCalculator })));
const NetWorthCalculator = lazy(() => import('./components/calculators/NetWorthCalculator').then((module) => ({ default: module.NetWorthCalculator })));
const FourZeroOneKCalculator = lazy(() => import('./components/calculators/FourZeroOneKCalculator').then((module) => ({ default: module.FourZeroOneKCalculator })));
const DebtPayoffCalculator = lazy(() => import('./components/calculators/DebtPayoffCalculator').then((module) => ({ default: module.DebtPayoffCalculator })));
const TaxCalculator = lazy(() => import('./components/calculators/TaxCalculator').then((module) => ({ default: module.TaxCalculator })));
const GoalsCalculator = lazy(() => import('./components/calculators/GoalsCalculator').then((module) => ({ default: module.GoalsCalculator })));
const RetirementPlanner = lazy(() => import('./components/calculators/RetirementPlanner').then((module) => ({ default: module.RetirementPlanner })));

const AdminLogin = lazy(() => import('./pages/AdminLogin').then((module) => ({ default: module.AdminLogin })));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard').then((module) => ({ default: module.AdminDashboard })));

const PageLoader: React.FC = () => (
  <div className="flex items-center justify-center py-16 text-sm text-gray-500 dark:text-gray-400">
    Loading…
  </div>
);

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <SharedDataProvider>
        <RouteSEO />
        <Layout>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/hourly-to-salary" element={<HourlyToSalary />} />
              <Route path="/take-home-pay" element={<TakeHomePay />} />
              <Route path="/cost-of-living" element={<CostOfLiving />} />
              <Route path="/retirement-calculator" element={<RetirementCalculator />} />
              <Route path="/loan-calculator" element={<LoanCalculator />} />
              <Route path="/investment-calculator" element={<InvestmentCalculator />} />
              <Route path="/interest-calculator" element={<InterestCalculator />} />
              <Route path="/budget-calculator" element={<BudgetCalculator />} />
              <Route path="/mortgage-calculator" element={<MortgageCalculator />} />
              <Route path="/savings-goal-calculator" element={<SavingsGoalCalculator />} />
              <Route path="/net-worth-calculator" element={<NetWorthCalculator />} />
              <Route path="/401k-calculator" element={<FourZeroOneKCalculator />} />
              <Route path="/debt-payoff-calculator" element={<DebtPayoffCalculator />} />
              <Route path="/tax-calculator" element={<TaxCalculator />} />
              <Route path="/goals-calculator" element={<GoalsCalculator />} />
              <Route path="/retirement-planner" element={<RetirementPlanner />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/freelance-rate" element={<TakeHomePay />} />
              <Route path="/salary-negotiation" element={<TakeHomePay />} />
            </Routes>
          </Suspense>
        </Layout>
      </SharedDataProvider>
    </BrowserRouter>
  );
};

export default App;
